import zdjecieRzeki1 from "../components/zdjecia/piesnirzekizdjecia/273544227_665905151216116_5188507921600526720_n.jpg";
import zdjecieRzeki2 from "../components/zdjecia/piesnirzekizdjecia/273787336_694136991765217_7285594843117192188_n.jpg";
import zdjecieRzeki3 from "../components/zdjecia/piesnirzekizdjecia/273810279_391081092827887_520503146332847715_n(1).jpg";
import zdjecieRzeki4 from "../components/zdjecia/piesnirzekizdjecia/274009930_662323684919210_3865141731487489515_n.jpg";
import bomba1 from "../components/zdjecia/dlamniebomba/BOMBA1.jpg";
import bomba2 from "../components/zdjecia/dlamniebomba/BOMBA2.jpg";
import bomba3 from "../components/zdjecia/dlamniebomba/BOMBA3.jpg";
import bomba4 from "../components/zdjecia/dlamniebomba/BOMBA4.jpg";
import bomba7 from "../components/zdjecia/dlamniebomba/BOMBA7.jpg";
import dom1 from "../components/zdjecia/domposterunkowazdjecia/410889792_813610654046308_695357546265633720_n.jpg";
import dom2 from "../components/zdjecia/domposterunkowazdjecia/410900383_813609617379745_465063396861842008_n.jpg";
import dom3 from "../components/zdjecia/domposterunkowazdjecia/410942358_813609044046469_6941253888996145115_n.jpg";
import dom4 from "../components/zdjecia/domposterunkowazdjecia/410955964_813610587379648_6216749358797622228_n.jpg";
import maluskiewicz1 from "../components/zdjecia/panmaluskiewiczzdjecia/343725558_803114631160114_1871107460480178052_n.jpg";
import maluskiewicz2 from "../components/zdjecia/panmaluskiewiczzdjecia/pan-maluskiewicz-02.jpg";
import maluskiewicz3 from "../components/zdjecia/panmaluskiewiczzdjecia/wieloryb - oko.jpg";
import nosferatu1 from "../components/zdjecia/nosferatuzdjecea/teatr w ogrodzie.jpg";
import nosferatu2 from "../components/zdjecia/nosferatuzdjecea/nr (48).JPG";
import nosferatu3 from "../components/zdjecia/nosferatuzdjecea/nr (44).JPG";
import nosferatu4 from "../components/zdjecia/nosferatuzdjecea/nr (38).JPG";
import nosferatu5 from "../components/zdjecia/nosferatuzdjecea/Animo Kwidzyn.jpg";
import nosferatu6 from "../components/zdjecia/nosferatuzdjecea/33.jpg";

const images = (files, title) => files.map((src, index) => ({
    src,
    alt: `${title} - zdjęcie ${index + 1}`,
}));

export const SPEKTAKLE_GALERIE = {
    rzeki: images([zdjecieRzeki1, zdjecieRzeki2, zdjecieRzeki3, zdjecieRzeki4], "Pieśni Rzeki"),
    bomba: images([bomba1, bomba2, bomba3, bomba4, bomba7], "Dla mnie Bomba!!!"),
    dom: images([dom1, dom2, dom3, dom4], "Dom Posterunkowa 1 Supraśl"),
    maluskiewicz: images([maluskiewicz1, maluskiewicz2, maluskiewicz3], "Pan Maluśkiewicz"),
    nosferatu: images(
        [nosferatu3, nosferatu2, nosferatu1, nosferatu4, nosferatu5, nosferatu6],
        "Nosferatu – dziennik zarazy"
    ),
};
